import { render, staticRenderFns } from "./ProtoLeftSidebar.vue?vue&type=template&id=09f3947c&scoped=true&"
import script from "./ProtoLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./ProtoLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProtoLeftSidebar.vue?vue&type=style&index=0&id=09f3947c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3947c",
  null
  
)

export default component.exports